// extracted by mini-css-extract-plugin
export default {"hiddenMessage":"NoDataMessage_hiddenMessage__Zlroa","boxMessage":"NoDataMessage_boxMessage__7r8dc"};